import React from 'react';

import styles from './css/AnchorName.module.css';


function AnchorName(props) {
  const { name } = props;
  let [firstName, ...lastName] = name?.split(' ');
  lastName = lastName?.join(' ');
  firstName = firstName || '';

  return (
    <div className={styles.anchorNameWrapper}>
      <div className={styles.firstNameWrapper}>
        <h1 className={`${styles.firstName} ${styles.front}`}>
          {firstName}
        </h1>
        <h1 className={`${styles.firstName} ${styles.back}`}>
          {firstName}
        </h1>
      </div>
      {lastName && <h2 className={styles.lastName}>
        {lastName}
      </h2>}
    </div>
  );
}

export default AnchorName;
